import { forEach, flatten } from 'lodash';
import flat from 'flat';

var distributeErrors = function (form, errors) {
    if (typeof errors === 'string') {
        errors = [errors];
    }
    if (errors.message) {
        return [errors.message];
    }

    var unmappedErrors = [];

    errors = flat.flatten(errors, { safe: true });

    forEach(errors, function (error, field) {
        if (form[field]) {
            form[field].$registerApiError(error);
        } else {
            unmappedErrors.push(error);
        }
    });

    return unmappedErrors;
};

class ApiFormController {

    handleSave () {
        this.form.$api = {
            reset: () => {
                this.form.$api.$error = null;
                this.form.$api.$invalid = false;
                this.form.$api.$valid = true;
            },

            setErrors: errors => {
                var unmappedErrors = distributeErrors(this.form, errors);
                this.form.$api.$error = unmappedErrors.length ? flatten(unmappedErrors) : null;
                this.form.$api.$valid = false;
                this.form.$api.$invalid = true;
            }
        };

        if (this.form.$valid && this.onSave) {
            this.saving = true;

            return this.onSave()
                .then(result => {
                    this.saving = false;

                    if (this.onSuccess) {
                        return this.onSuccess({ result });
                    }
                })
                .catch(errors => {
                    this.saving = false;
                    if (errors.data) {
                        this.form.$api.setErrors(errors.data);
                    }
                    if (this.onError) {
                        return this.onError({ errors });
                    }
                });
        }
    }
}

ApiFormController.$inject = [];

export default ApiFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/controllers/api.form.controller.js